import * as React from "react";
var ManagerReferenceNodeContext = React.createContext(), ManagerReferenceNodeSetterContext = React.createContext();
function Manager(_ref) {
  var children = _ref.children, _React$useState = React.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1], hasUnmounted = React.useRef(!1);
  React.useEffect(function() {
    return function() {
      hasUnmounted.current = !0;
    };
  }, []);
  var handleSetReferenceNode = React.useCallback(function(node) {
    hasUnmounted.current || setReferenceNode(node);
  }, []);
  return /* @__PURE__ */ React.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /* @__PURE__ */ React.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}
export {
  Manager as M,
  ManagerReferenceNodeSetterContext as a,
  ManagerReferenceNodeContext as b
};
//# sourceMappingURL=Manager-52cb3832.js.map
